import { render, staticRenderFns } from "./EditRecord.vue?vue&type=template&id=491dff4d&"
import script from "./EditRecord.vue?vue&type=script&lang=js&"
export * from "./EditRecord.vue?vue&type=script&lang=js&"
import style0 from "./EditRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports